import { gql } from "@apollo/client";

export const PENDING_INVOICES_BY_ID = gql`
  query pendingInvoicesByPetId($petId: String!) {
    pendingInvoicesByPetId(
      petId: $petId,
    ) {
        success
        messages
        pendingSquareInvoices {
            publicUrl
            amount
            dueDate
        }
    }
  }
`;
